import {MarvColorBlue, MarvColorPurple, MarvColorGreen, MarvColorPrimary} from '@marv/types';

export const environment = {
    production: false,
    ENV_NAME: 'staging',
    URL_API_BACKEND: 'https://staging-lo-api.loga.one/api/',
    NB_DAYS_TOKEN_LOGIN : 15,
    COOKIE_LOGIN: 'token_login',
    COOKIE_DOMAIN: '.marving.app',
    PREFIX_LOCALSTORAGE: 'marving_staging',
    KEY_EXTERNAL_TOKEN: 'Gr3G4S3nSKrft392',
    GOOGLE_MAP_KEY: 'AIzaSyCih6BegTbcDEHGYnfT3CnVrxNXbzKoVew',
    URL_MARVING: 'https://marving.atmospheres3.fr/',
    URL_FORGOT_PASSWORD: '',
    ANIMA_REPORTS_URL: 'https://anima.agence-impact.com/reports',
    URL_LOGO_RETAILER: 'https://loga-icons.impgrp.info/icons/#retailer_name#/64.png',
    MISSION_TYPE_ANIM: 'ANIM',
    MISSION_TYPE_MERCH_HORAIRE: 'MERCH_HORAIRE',
    MISSION_TYPE_MERCH: 'MERCH',
    MISSION_TYPE_PERM: 'PERM',
    MISSIONS_TYPES: [
        {code: 'ANIM', name: 'ANIMATION', color: MarvColorBlue},
        {code: 'MERCH_HORAIRE', name: 'MERCH_HORAIRE', color: MarvColorPurple},
        {code: 'MERCH', name: 'MERCH', color: MarvColorGreen},
        {code: 'PERM', name: 'PERMANENT', color: MarvColorPrimary}
    ],
    USER_PROFIL_SECTOR: 'SECTOR',
    USER_PROFIL_AREA: 'AREA',
    USER_PROFIL_FIELDTEAM: 'FIELDTEAM'
};
